// Module
var code = "<md-button id=\"{{ $ctrl.tooltipId }}\" class=\"{{ $ctrl.class }}\" aria-label=\"{{ $ctrl.tooltip }}\" data-tooltip=\"{{ $ctrl.tooltip }}\"> <md-icon md-svg-icon=\"{{ $ctrl.icon }}\"></md-icon> </md-button> ";
// Exports
module.exports = code;